import { detect } from "detect-browser";

export const detectSafariBrowser = () => detect()?.name === "safari" || detect()?.name === "ios";
